import React, { Component } from 'react';
import { Switch, Input, Button, message } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import { SvgIconText } from 'freesia-ui';
// import FileViewer from '../../../../framework/file-viewer';

export default class FileUrlEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    showFileViewer() {
        this.fileViewerRef.show();
    }
    selectFile() {
        let files = this.fileViewerRef.getSelectedData();
        let file = files[0];
        let msg = '请选择一个文件';
        if (!file || file.type === 'dir' || file.type === 'directory') {
            message.warning(msg);
            return;
        }
        let splits = file.name.split('.')
        let extName = splits[splits.length - 1];
        let { formats } = this.props.source;
        if (formats && formats.indexOf(extName.toLowerCase()) === -1) {
            message.warning(`仅支持格式为${formats.join('、')}的文件`);
            return;
        }
        let url = this.fileViewerRef.getDownloadUrl(file);
        this.props.source.value = window.top.location.origin + url;
        this.fileViewerRef.hide();
    }
    render() {

        return (<div>
            <Input value={this.props.source.value} onChange={e => this.onChange(e)} addonAfter={
                <div style={{
                    cursor: "pointer"
                }} onClick={e => this.showFileViewer()}>
                    <SvgIconText type="#anticon-folder5" title="从数据堡中选择"></SvgIconText>
                </div>
            }></Input>
            {/* <FileViewer
                ref={ref => this.fileViewerRef = ref}
                mode="singleSelect"
                footer={<div>
                    <Button onClick={e => this.fileViewerRef.hide()}>取 消</Button>
                    <Button type="primary" onClick={e => {
                        this.selectFile();
                    }} >确 定</Button>
                </div>}
            ></FileViewer> */}
        </div>
        );
    }
}

PropertyGridUtils.register("fileUrl", (source, propertyGrid) => <FileUrlEditor source={source} propertyGrid={propertyGrid} />);